const BaseUrl = "architorture-api.app.alistairfink.com";

export const ApiBaseUrl = "https://" + BaseUrl + "/";
export const WsBaseUrl = "wss://" + BaseUrl + "/ws";